import { actions } from '@ecosystem/newron-design-system';

interface WithExportButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export const WithExportButton = ({ onClick, disabled }: WithExportButtonProps) => {
  const { Button } = actions;
  return (
    <Button mode="secondary" testId="export-chart-btn" label="Export chart" onClick={onClick} disabled={disabled}>
      <Button.Icon>
        <Button.Icon.icons.Export />
      </Button.Icon>
    </Button>
  );
};
